module.exports = __webpack_public_path__ + "img/blue_006.44599c6e.png";